/* eslint-disable @typescript-eslint/no-explicit-any */
window.abtest = {};
